export const HeaderOptions = [
  {
    value: "my_task",
    text: "My Task",
  },
  {
    value: "all_task",
    text: "All Task",
  },
];
export const addDocOptions = [
  {
    val: "addLink",
    text: "Add Link",
  },
  {
    val: "upload",
    text: "Upload",
  },
];
